
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { HelpCircle, Ticket } from 'lucide-react';

const HelpSection: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Need Help?</CardTitle>
          <CardDescription>Get support with your royalties or payments</CardDescription>
        </div>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Alert>
          <HelpCircle className="h-4 w-4" />
          <AlertTitle>Browse FAQ</AlertTitle>
          <AlertDescription>
            Find answers to common questions in our help center.
            <div className="mt-2">
              <Button variant="outline" onClick={() => navigate('/author/help')}>
                Visit Help Center
              </Button>
            </div>
          </AlertDescription>
        </Alert>
        <Alert>
          <Ticket className="h-4 w-4" />
          <AlertTitle>Contact Support</AlertTitle>
          <AlertDescription>
            Still have questions? Create a support ticket.
            <div className="mt-2">
              <Button 
                variant="outline" 
                onClick={() => navigate('/author/help')}
                className="border-brand-300 text-brand-700 hover:bg-brand-50"
              >
                Create Ticket
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};

export default HelpSection;
